import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10 mb-14">
          <div>
            <h4 className="font-label text-sm font-semibold text-foreground-950 mb-4 uppercase tracking-wider">
              {t('nav_categories')}
            </h4>
            <div className="w-8 h-px bg-background-300 mb-4"></div>
            <div className="flex flex-col gap-2.5">
              {categories.map((cat) => (
                <a
                  key={cat.id}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-label text-sm font-semibold text-foreground-950 mb-4 uppercase tracking-wider">
              {t('nav_guide')}
            </h4>
            <div className="w-8 h-px bg-background-300 mb-4"></div>
            <div className="flex flex-col gap-2.5">
              <Link to="/guia-hoobuy-spreadsheet-2026" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                Guia Completo 2026
              </Link>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                Hoobuy Sheet
              </a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                Buy It Now
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-label text-sm font-semibold text-foreground-950 mb-4 uppercase tracking-wider">
              Comparação
            </h4>
            <div className="w-8 h-px bg-background-300 mb-4"></div>
            <div className="flex flex-col gap-2.5">
              <Link to="/comparacao-hoobuy-pandabuy" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                Hoobuy vs Pandabuy
              </Link>
              <Link to="/comparacao-hoobuy-pandabuy" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                Hoobuy vs Agentes
              </Link>
              <Link to="/seguranca-compras-hoobuy" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                Segurança Hoobuy
              </Link>
            </div>
          </div>

          <div>
            <h4 className="font-label text-sm font-semibold text-foreground-950 mb-4 uppercase tracking-wider">
              Blog
            </h4>
            <div className="w-8 h-px bg-background-300 mb-4"></div>
            <div className="flex flex-col gap-2.5">
              <Link to="/guia-iniciantes-hoobuy" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                Guia Completo
              </Link>
              <Link to="/como-economizar-hoobuy" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                Dicas de Compra
              </Link>
              <Link to="/listas-hoobuy-atualizadas-2026" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                Listas Atualizadas
              </Link>
            </div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-6 pt-8 border-t border-background-200/70">
          <div>
            <Link to="/" className="font-heading text-2xl font-bold text-foreground-950">
              HooBuy
            </Link>
            <div className="w-8 h-px bg-background-300 mt-2 mb-2"></div>
            <p className="text-xs text-foreground-500">{t('footer_description')}</p>
          </div>

          <div className="flex flex-col sm:items-end gap-3">
            <div className="flex gap-4">
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:text-primary-500 hover:bg-background-300 transition-colors duration-200 cursor-pointer">
                <i className="ri-twitter-x-line"></i>
              </a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:text-primary-500 hover:bg-background-300 transition-colors duration-200 cursor-pointer">
                <i className="ri-instagram-line"></i>
              </a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:text-primary-500 hover:bg-background-300 transition-colors duration-200 cursor-pointer">
                <i className="ri-telegram-line"></i>
              </a>
            </div>
            <p className="text-xs text-foreground-500">{t('footer_copyright')}</p>
          </div>
        </div>
      </div>
    </footer>
  );
}